module.exports = __webpack_public_path__ + "static/media/mail-send.82880ec3.gif";